import { render, staticRenderFns } from "./WeaponBuilds.vue?vue&type=template&id=4a78912e"
import script from "./WeaponBuilds.vue?vue&type=script&lang=ts"
export * from "./WeaponBuilds.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports